export var ListTypeTokens;
(function (ListTypeTokens) {
    ListTypeTokens["CHECKLIST"] = "CHECKLIST";
    ListTypeTokens["DEFUALTLIST"] = "DEFUALTLIST";
})(ListTypeTokens || (ListTypeTokens = {}));
